/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppConfig } from '../../models/app-config';
import { AppConfigUpdateDto } from '../../models/app-config-update-dto';

export interface UpdateAppConfigByName$Params {
  name: 'logo' | 'urls' | 'messages';
  body: AppConfigUpdateDto;
}

export function updateAppConfigByName(
  http: HttpClient,
  rootUrl: string,
  params: UpdateAppConfigByName$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<AppConfig>> {
  const rb = new RequestBuilder(rootUrl, updateAppConfigByName.PATH, 'put');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AppConfig>;
    })
  );
}

updateAppConfigByName.PATH = '/admin/app-configs/{name}';
